import { TrackVisitDto } from '@libs/dto';

import { api } from '../common.api';

export const statsApi = api.injectEndpoints({
  endpoints: (build) => ({
    trackNov25Visit: build.mutation<{ recorded: boolean; message: string }, TrackVisitDto>({
      query: (body) => ({
        url: '/stats/nov25/track',
        method: 'POST',
        body,
      }),
    }),
    getNov25TotalVisits: build.query<{ total: number }, void>({
      query: () => ({
        url: '/stats/nov25/total',
        method: 'GET',
      }),
    }),
    getNov25VisitsByPeriod: build.query<
      Array<{ period: string; count: number }>,
      { period: 'day' | 'week' | 'month' | 'year' }
    >({
      query: ({ period = 'day' }) => ({
        url: '/stats/nov25/by-period',
        method: 'GET',
        params: { period },
      }),
    }),
    getNov25DeviceBreakdown: build.query<Array<{ deviceType: string; count: number }>, void>({
      query: () => ({
        url: '/stats/nov25/devices',
        method: 'GET',
      }),
    }),
    getNov25TopReferrers: build.query<Array<{ referrer: string; count: number }>, { limit?: number }>({
      query: ({ limit = 10 } = {}) => ({
        url: '/stats/nov25/referrers',
        method: 'GET',
        params: { limit },
      }),
    }),
    trackNiadaVisit: build.mutation<{ recorded: boolean; message: string }, TrackVisitDto>({
      query: (body) => ({
        url: '/stats/niada/track',
        method: 'POST',
        body,
      }),
    }),
    getNiadaTotalVisits: build.query<{ total: number }, void>({
      query: () => ({
        url: '/stats/niada/total',
        method: 'GET',
      }),
    }),
    getNiadaVisitsByPeriod: build.query<
      Array<{ period: string; count: number }>,
      { period: 'day' | 'week' | 'month' | 'year' }
    >({
      query: ({ period = 'day' }) => ({
        url: '/stats/niada/by-period',
        method: 'GET',
        params: { period },
      }),
    }),
    getNiadaDeviceBreakdown: build.query<Array<{ deviceType: string; count: number }>, void>({
      query: () => ({
        url: '/stats/niada/devices',
        method: 'GET',
      }),
    }),
    getNiadaTopReferrers: build.query<Array<{ referrer: string; count: number }>, { limit?: number }>({
      query: ({ limit = 10 } = {}) => ({
        url: '/stats/niada/referrers',
        method: 'GET',
        params: { limit },
      }),
    }),
    trackExcelsusVisit: build.mutation<{ recorded: boolean; message: string }, TrackVisitDto>({
      query: (body) => ({
        url: '/stats/excelsus/track',
        method: 'POST',
        body,
      }),
    }),
    getExcelsusTotalVisits: build.query<{ total: number }, void>({
      query: () => ({
        url: '/stats/excelsus/total',
        method: 'GET',
      }),
    }),
    getExcelsusVisitsByPeriod: build.query<
      Array<{ period: string; count: number }>,
      { period: 'day' | 'week' | 'month' | 'year' }
    >({
      query: ({ period = 'day' }) => ({
        url: '/stats/excelsus/by-period',
        method: 'GET',
        params: { period },
      }),
    }),
  }),
});

export const {
  useTrackNov25VisitMutation,
  useGetNov25TotalVisitsQuery,
  useGetNov25VisitsByPeriodQuery,
  useGetNov25DeviceBreakdownQuery,
  useGetNov25TopReferrersQuery,
  useTrackNiadaVisitMutation,
  useGetNiadaTotalVisitsQuery,
  useGetNiadaVisitsByPeriodQuery,
  useGetNiadaDeviceBreakdownQuery,
  useGetNiadaTopReferrersQuery,
  useTrackExcelsusVisitMutation,
  useGetExcelsusTotalVisitsQuery,
  useGetExcelsusVisitsByPeriodQuery,
} = statsApi;
